import React, { useState } from "react";
import styled from "styled-components";
import SendIcon from "@material-ui/icons/Send";
import FormatBoldIcon from "@material-ui/icons/FormatBold";
import FormatItalicIcon from "@material-ui/icons/FormatItalic";
import AttachFileOutlinedIcon from "@material-ui/icons/AttachFileOutlined";

function ChatInput({ sendMessage }) {
  const [input, setInput] = useState("");

  const send = (e) => {
    e.preventDefault();
    if (!input) return;
    sendMessage(input);
    setInput("");
  };

  return (
    <Container>
      <InputContainer>
        <form>
          <input
            onChange={(e) => setInput(e.target.value)}
            type="text"
            value={input}
            placeholder=" Message here..."
          ></input>
          <SendButton 
          type="submit"
          onClick={send}>
            <Send />
          </SendButton>
        </form>
        <IconsContainer>
          <Bold />
          <Italic />
          <Attach />
        </IconsContainer>
      </InputContainer>
    </Container>
  );
}

export default ChatInput;

const Container = styled.div`
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 24px;
`;

const InputContainer = styled.div`
  border: 1px solid #8d8d8e;
  border-radius: 4px;
  form {
    display: flex;
    height: 42px;
    align-items: center;
    padding-left: 10px;
    input {
      flex: 1;
      border: none;
      font-size: 13px;
    }

    input:focus {
      outline: none;
    }
  }
`;

const SendButton = styled.button`
  background: #007a5a;
  border-radius: 2px;
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 5px;
  cursor: pointer;
  border: none;

  .MuiSvgIcon-root {
    width: 18px;
  }

  :hover {
    background: #148567;
  }
`;

const Send = styled(SendIcon)`
  color: #d9d9d9;
`;

const IconsContainer = styled.div`
  background: #f5f0ec;
  padding: 5px 5px;
  display: flex;
  border-top: 1px solid #d9d9d9;
  align-items: left;
`;

const Bold = styled(FormatBoldIcon)`
  color: grey;
  cursor: pointer;
  border-radius: 4px;
  :hover {
    background: #d9d9d9;
  }
`;

const Italic = styled(FormatItalicIcon)`
  color: grey;
  cursor: pointer;
  border-radius: 4px;
  :hover {
    background: #d9d9d9;
  }
`;

const Attach = styled(AttachFileOutlinedIcon)`
  color: grey;
  cursor: pointer;
  border-radius: 4px;
  :hover {
    background: #d9d9d9;
  }
`;
